/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {translate} from '@ion/core/src/locale/locale';
import {CTALink} from '@ion/dls/src/components/buttons/CTALink';
import {AuditRecordType} from '@ion/dls/src/editors/audit/AuditGridUtils';
import {dlsColor, dlsTypography} from '@ion/dls/src/theme/theme';

export interface AuditRowMenuEditorType {
  data?: AuditRecordType;
  onViewAuditChanges: Function;
}

const useStyles = makeStyles(theme => {
  return {
    ctaLink : {
      ...dlsTypography('cta'),
      color          : dlsColor('aaBlue'),
      cursor         : 'pointer',
      letterSpacing  : '1px',
      lineHeight     : 'inherit',
      fontSize       : 'inherit',
      display        : 'flex',
      justifyContent : 'center',
      alignItems     : 'center'
    }
  };
});

export const AuditRowMenuEditor = ({
  data: auditRecord, onViewAuditChanges: onViewAuditChangesParent
}: AuditRowMenuEditorType) => {
  const classes = useStyles();

  function onViewAuditChanges() {
    onViewAuditChangesParent(auditRecord, true);
  };

  return (
    <CTALink className={classes.ctaLink}
      onClick={onViewAuditChanges}>
      {translate('common:view')}
    </ CTALink>
  );
};
export default AuditRowMenuEditor;
